// src/store/store.ts
import { configureStore } from '@reduxjs/toolkit';

import adminReducer from './slices/admin';
import tenantReducer from './slices/tenant/index';
import userReducer from './slices/user-slices';

const store = configureStore({
  reducer: {
    users: userReducer,
    admin: adminReducer,
    tenant: tenantReducer,
  },
});

// Type helpers
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
